module.exports = __webpack_public_path__ + "static/media/minus.c595b576.svg";